import { useEffect, useState } from 'react'
import { collection, onSnapshot } from 'firebase/firestore'
import { db } from '../../../../firebase'
import { useParams } from 'react-router-dom'

import Header from '../../Header/Header'

import './premium.css'

function CourseDetail() {
  const { courseId } = useParams()
  const [lessons, setLessons] = useState([])

  useEffect(() => {
    const lessonsCollection = collection(db, 'courses', courseId, 'lessons')
    const unsubscribe = onSnapshot(lessonsCollection, (snapshot) => {
      const lessonsArray = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      setLessons(lessonsArray)
    })
    return () => unsubscribe()
  }, [courseId])

  return (
    <>
      <Header />

      <h2>Уроки курса</h2>
      {lessons.length === 0 ? (
        <p>Уроков пока нет</p>
      ) : (
        <ul>
          {lessons.map((lesson, index) => (
            <li key={lesson.id} className='lessons'>
              Урок {index + 1}: <h2>{lesson.title}</h2>
              {lesson.videoURL && (
                <a className='see-video' href={lesson.videoURL} target="_blank" rel="noreferrer">
                  Смотреть видео
                </a>
              )}
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

export default CourseDetail
